<template>
  <div class="aside-nav" v-if="admin">
    <div>
      <div class="aside-nav__head">
        <div class="aside-nav__logo">
          <logo />
        </div>
      </div>

      <div class="aside-nav__menu">
        <router-link v-if="$guard('read', 'Calendar')" to="/admin/calendar" class="aside-nav__item">
          <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              stroke="var(--menu-text-color)"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
                cx="22.1399"
                cy="18.2728"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="18.3982"
                cy="18.2728"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="18.3982"
                cy="22.0909"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="14.6565"
                cy="22.0909"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="18.3982"
                cy="14.4546"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="22.1399"
                cy="14.4546"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24.8127 27V7.75321C24.8127 6.63429 24.0852 5.72723 23.1877 5.72723H6.12502C5.22755 5.72723 4.5 6.63429 4.5 7.75321V27H24.8127Z"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <ellipse
                cx="14.6565"
                cy="14.4546"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="14.6565"
                cy="18.2728"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <path
                d="M7.70752 5.45455C7.70752 4.09894 8.78448 3 10.113 3C11.4415 3 12.5184 4.09894 12.5184 5.45455C12.5184 6.81015 11.4415 7.90909 10.113 7.90909"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M17.3291 5.45455C17.3291 4.09894 18.4061 3 19.7346 3C21.0631 3 22.14 4.09894 22.14 5.45455C22.14 6.81015 21.0631 7.90909 19.7346 7.90909"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <ellipse
                cx="14.6565"
                cy="11.1819"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="18.3982"
                cy="11.1819"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="22.1399"
                cy="11.1819"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <path
                d="M5.13172 25.2338H24.8054"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <ellipse
                cx="7.17261"
                cy="14.4546"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="10.9143"
                cy="14.4546"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="7.17261"
                cy="18.2728"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="7.17261"
                cy="22.0909"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="10.9143"
                cy="18.2728"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="10.9143"
                cy="22.0909"
                rx="1.06909"
                ry="1.09091"
                fill="var(--menu-text-color)"
            />
          </svg>

          <span class="aside-nav__item-text">{{ $t("navigation.calendar") }}</span>
        </router-link>

        <router-link v-if="$guard('read', 'Masters')" to="/admin/masters" class="aside-nav__item">
          <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.6225 8.72445C20.6225 8.72445 19.872 4.12635 16.3997 3.79799C16.3528 3.75108 16.4935 3 15.3202 3C14.1475 3 14.2882 3.75108 14.2413 3.79799C10.7696 4.12635 10.0185 8.72445 10.0185 8.72445L9.40869 9.42863C9.83087 11.1642 15.3202 11.1642 15.3202 11.1642C15.3202 11.1642 20.8101 11.1642 21.2323 9.42863L20.6225 8.72445Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.2967 11.9855C13.4897 11.9855 11.7759 11.74 10.2388 11.302C10.1624 11.6282 10.1221 11.9664 10.1221 12.3138C10.1221 13.6589 10.7253 14.8747 11.6957 15.7441C12.0922 17.5316 13.5644 18.8592 15.3202 18.8592C17.076 18.8592 18.5481 17.5316 18.9447 15.7441C19.9156 14.8747 20.5188 13.6589 20.5188 12.3138C20.5188 11.962 20.4774 11.6195 20.3988 11.2895C18.8503 11.7357 17.1212 11.9855 15.2967 11.9855Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.3202 19.4456C21.6779 18.5074 18.8628 17.428 18.8628 17.428C18.8628 17.428 17.5019 19.4925 15.2967 19.4925C13.0915 19.4925 11.7306 17.428 11.7306 17.428C11.7306 17.428 8.91554 18.5074 7.27375 19.4456C5.63141 20.3843 4.41125 23.4339 4.50507 25.17C5.72523 26.9062 15.2967 27 15.2967 27C15.2967 27 24.8682 26.9062 26.0884 25.17C26.1822 23.4339 24.9626 20.3843 23.3202 19.4456Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.5874 19.5396L10.2766 18.8823V22.4954H8.5874V19.5396Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.1004 19.5396L20.4111 18.8823V22.4954H22.1004V19.5396Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.2967 26.2021C15.2967 26.2021 19.9035 26.1569 23.1326 25.5498V24.1065C23.1326 23.6058 22.7262 23.1995 22.2249 23.1995H8.46225C7.96153 23.1995 7.55518 23.6058 7.55518 24.1065V25.5672C10.7788 26.158 15.2967 26.2021 15.2967 26.2021Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
          </svg>

          <span class="aside-nav__item-text">{{ $t("navigation.masters") }}</span>
        </router-link>

        <router-link v-if="$guard('read', 'Clients')" to="/admin/clients" class="aside-nav__item">
          <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.3998 3C10.906 3 9.35754 5.08059 9.35754 8.12287C9.28152 8.44766 9.24121 8.78512 9.24121 9.13179C9.24121 10.473 9.84241 11.6846 10.8099 12.5507C11.2055 14.333 12.6728 15.6563 14.4234 15.6563C16.1734 15.6563 17.6407 14.333 18.0364 12.5507C19.0038 11.6846 19.6056 10.473 19.6056 9.13179C19.6056 8.78109 19.5636 8.43902 19.4858 8.11021C19.4858 4.4863 17.9402 3 14.3998 3Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.8692 19.0249C21.1353 18.0344 18.1633 16.8948 18.1633 16.8948C18.1633 16.8948 17.4699 22.3937 14.3989 25.3657C11.2282 22.3436 10.6339 16.8948 10.6339 16.8948C10.6339 16.8948 7.66183 18.0344 5.92791 19.0249C4.19399 20.0154 2.90578 23.2356 3.00541 25.0686C4.29304 26.901 14.3989 27 14.3989 27C14.3989 27 24.5041 26.901 25.7917 25.0686C25.8908 23.2356 24.6031 20.0154 22.8692 19.0249Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.2593 18.6782H15.4884L15.1418 20.3125H13.6059L13.2593 18.6782Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.4884 22.2941L14.4479 24.5728L13.2593 22.2941L13.6059 20.6599H15.1412L15.4884 22.2941Z"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                d="M11.5005 3.66864C11.5005 3.66864 13.1849 8.37459 15.9093 8.32507C19.6322 8.25769 19.4739 7.5822 19.4739 7.5822"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
            <path
                d="M13.086 6.59131C13.086 6.59131 11.7488 9.01857 9.37109 8.12713"
                stroke="var(--menu-text-color)"
                stroke-linejoin="round"
            />
          </svg>

          <span class="aside-nav__item-text">{{ $t("navigation.clients") }}</span>
          <div class="aside-nav__item-notifications" v-if="newClients !== 0">
            <span>{{ newClients }}</span>
          </div>
        </router-link>

        <router-link to="/admin/offices" class="aside-nav__item">
          <svg
              id="Capa_1"
              enable-background="new 0 0 512 512"
              width="25"
              height="25"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="var(--menu-text-color)"
              style="margin-right: 5px"
          >
            <g>
              <g>
                <path
                    d="m485.344 458.604h-7.501v-230.62c0-10.483-8.529-19.012-19.013-19.012h-136.09v-183.444c0-14.03-11.415-25.445-25.445-25.445h-237.692c-14.03 0-25.445 11.415-25.445 25.445v433.075h-7.501c-14.699.001-26.657 11.959-26.657 26.658 0 14.698 11.958 26.656 26.656 26.656h458.688c14.698 0 26.656-11.958 26.656-26.656 0-14.699-11.958-26.657-26.656-26.657zm-436.187-433.076c0-5.76 4.686-10.445 10.445-10.445h237.692c5.76 0 10.445 4.686 10.445 10.445v183.444h-64.021c-10.484 0-19.014 8.528-19.014 19.012v172.483c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-172.483c0-2.212 1.801-4.012 4.014-4.012h215.112c2.213 0 4.013 1.8 4.013 4.012v230.619h-223.138v-23.073c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v23.073h-175.548zm436.187 471.389h-458.688c-6.428 0-11.656-5.229-11.656-11.656s5.229-11.657 11.656-11.657h458.688c6.428 0 11.656 5.229 11.656 11.657s-5.229 11.656-11.656 11.656z"
                />
                <path
                    d="m117.329 45.787h-30.771c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m193.835 45.787h-30.772c-8.194 0-14.861 6.667-14.861 14.862v30.771c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m239.567 106.283h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.772c0-8.195-6.667-14.862-14.862-14.862h-30.772c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.196 6.667 14.863 14.862 14.863zm.138-45.496h30.497v30.496h-30.497z"
                />
                <path
                    d="m117.329 139.412h-30.771c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m193.835 139.412h-30.772c-8.194 0-14.861 6.667-14.861 14.862v30.771c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m239.567 199.908h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862h-30.772c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862zm.138-45.496h30.497v30.496h-30.497z"
                />
                <path
                    d="m117.329 233.036h-30.771c-8.195 0-14.862 6.667-14.862 14.862v30.771c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m193.835 233.036h-30.772c-8.194 0-14.861 6.667-14.861 14.862v30.771c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.771c0-8.195-6.667-14.862-14.862-14.862zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m117.329 326.661h-30.771c-8.195 0-14.862 6.667-14.862 14.861v30.772c0 8.195 6.667 14.862 14.862 14.862h30.771c8.195 0 14.862-6.667 14.862-14.862v-30.772c0-8.194-6.667-14.861-14.862-14.861zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m193.835 326.661h-30.772c-8.194 0-14.861 6.667-14.861 14.861v30.772c0 8.195 6.667 14.862 14.861 14.862h30.772c8.195 0 14.862-6.667 14.862-14.862v-30.772c0-8.194-6.667-14.861-14.862-14.861zm-.138 45.496h-30.496v-30.496h30.496z"
                />
                <path
                    d="m270.159 302.88h29.141c7.067 0 12.816-5.749 12.816-12.815v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.141c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.066 5.749 12.815 12.816 12.815zm2.184-39.033h24.773v24.033h-24.773z"
                />
                <path
                    d="m270.159 364.189h29.141c7.067 0 12.816-5.749 12.816-12.816v-28.4c0-7.067-5.749-12.816-12.816-12.816h-29.141c-7.067 0-12.816 5.749-12.816 12.816v28.4c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.033h24.773v24.033h-24.773z"
                />
                <path
                    d="m270.159 425.499h29.141c7.067 0 12.816-5.749 12.816-12.816v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.141c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.034h24.773v24.034h-24.773z"
                />
                <path
                    d="m336.703 302.88h29.142c7.067 0 12.816-5.749 12.816-12.815v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.066 5.749 12.815 12.816 12.815zm2.184-39.033h24.774v24.033h-24.774z"
                />
                <path
                    d="m336.703 364.189h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.4c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.4c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.033h24.774v24.033h-24.774z"
                />
                <path
                    d="m336.703 425.499h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.034h24.774v24.034h-24.774z"
                />
                <path
                    d="m403.248 302.88h29.142c7.067 0 12.816-5.749 12.816-12.815v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.066 5.749 12.815 12.816 12.815zm2.184-39.033h24.774v24.033h-24.774z"
                />
                <path
                    d="m403.248 364.189h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.4c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.4c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.033h24.774v24.033h-24.774z"
                />
                <path
                    d="m403.248 425.499h29.142c7.067 0 12.816-5.749 12.816-12.816v-28.401c0-7.067-5.749-12.816-12.816-12.816h-29.142c-7.067 0-12.816 5.749-12.816 12.816v28.401c0 7.067 5.749 12.816 12.816 12.816zm2.184-39.034h24.774v24.034h-24.774z"
                />
                <path
                    d="m409.222 173.787c5.141 3.754 12.053 3.756 17.195 0 12.97-9.473 44.086-35.442 52.868-71.912.97-4.027-1.509-8.078-5.536-9.048-4.028-.965-8.078 1.51-9.048 5.536-7.762 32.233-37.515 56.248-46.882 63.128-11.785-8.652-48.787-39.035-48.787-78.903 0-26.901 21.886-48.787 48.786-48.787 21.132 0 39.761 13.476 46.356 33.532 1.294 3.935 5.533 6.077 9.468 4.782 3.935-1.294 6.076-5.533 4.782-9.468-8.625-26.227-32.98-43.847-60.606-43.847-35.172 0-63.786 28.615-63.786 63.787 0 47.223 42.242 81.744 55.19 91.2z"
                />
                <path
                    d="m417.818 47.112c-19.561 0-35.475 15.914-35.475 35.476s15.914 35.476 35.475 35.476c19.562 0 35.476-15.914 35.476-35.476s-15.914-35.476-35.476-35.476zm0 55.951c-11.29 0-20.475-9.186-20.475-20.476s9.185-20.476 20.475-20.476 20.476 9.186 20.476 20.476-9.186 20.476-20.476 20.476z"
                />
              </g>
            </g>
          </svg>

          <span class="aside-nav__item-text">Niederlassungen</span>
        </router-link>
        <!-- <router-link
          v-if="$guard('read', 'Partners')"
          to="/admin/partners"
          class="aside-nav__item"
        >
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <img src="/images/partners.svg" width="40px" height="50px" alt="" />
          </div>
          <span class="aside-nav__item-text">{{
            $t("navigation.partners")
          }}</span>
        </router-link>-->

        <router-link v-if="$guard('read', 'Chat')" to="/admin/chat" class="aside-nav__item">
          <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.35597 3C5.33579 3 4.5 3.8313 4.5 4.84589V10.3836C4.5 11.3982 5.33579 12.2294 6.35597 12.2294H7.28395V14.5368C7.28328 14.7228 7.39495 14.8911 7.5672 14.9635C7.73947 15.036 7.93862 14.9985 8.07236 14.8685L10.7911 12.2294H15.6358C16.656 12.2294 17.4917 11.3982 17.4917 10.3836V4.84589C17.4917 3.8313 16.656 3 15.6358 3H6.35597Z"
                stroke="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.1811 15C23.2013 15 24.0371 15.8313 24.0371 16.8459V22.3836C24.0371 23.3982 23.2013 24.2294 22.1811 24.2294H21.2532V26.5368C21.2538 26.7228 21.1422 26.8911 20.9699 26.9635C20.7976 27.036 20.5985 26.9985 20.4647 26.8685L17.746 24.2294H12.9013C11.8811 24.2294 11.0454 23.3982 11.0454 22.3836V16.8459C11.0454 15.8313 11.8811 15 12.9013 15H22.1811Z"
                stroke="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.1367 5.7769C21.9458 5.77835 21.7748 5.89247 21.7044 6.06542C21.634 6.23838 21.6782 6.43568 21.8161 6.56432L22.4224 7.14818H19.8695C19.8537 7.14741 19.8378 7.14741 19.8219 7.14818C19.6543 7.15642 19.504 7.25118 19.4275 7.39679C19.3511 7.54239 19.3602 7.7167 19.4513 7.854C19.5425 7.9913 19.702 8.07074 19.8695 8.06238H22.4224L21.8161 8.64624C21.6857 8.75828 21.6296 8.93142 21.6703 9.09614C21.711 9.26087 21.8418 9.39015 22.0102 9.43208C22.1786 9.474 22.357 9.4217 22.4737 9.29618L23.8971 7.93026C23.9867 7.84431 24.0371 7.72691 24.0371 7.60439C24.0371 7.48187 23.9867 7.36447 23.8971 7.27854L22.4737 5.9126C22.3848 5.8249 22.2632 5.77598 22.1367 5.7769Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.9463 6.57022C10.3986 6.57022 9.95459 7.01422 9.95459 7.56196C9.95459 8.1097 10.3986 8.55369 10.9463 8.55369C11.4941 8.55369 11.9381 8.1097 11.9381 7.56196C11.9381 7.01422 11.4941 6.57022 10.9463 6.57022Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.4175 6.57022C13.8698 6.57022 13.4258 7.01422 13.4258 7.56196C13.4258 8.1097 13.8698 8.55369 14.4175 8.55369C14.9652 8.55369 15.4093 8.1097 15.4093 7.56196C15.4093 7.01422 14.9652 6.57022 14.4175 6.57022Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.47515 6.57022C6.9274 6.57022 6.4834 7.01422 6.4834 7.56196C6.4834 8.1097 6.9274 8.55369 7.47515 8.55369C8.02287 8.55369 8.46687 8.1097 8.46687 7.56196C8.46687 7.01422 8.02287 6.57022 7.47515 6.57022Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.9628 18.5703C21.5106 18.5703 21.9546 19.0142 21.9546 19.562C21.9546 20.1097 21.5106 20.5537 20.9628 20.5537C20.4151 20.5537 19.9711 20.1097 19.9711 19.562C19.9711 19.0142 20.4151 18.5703 20.9628 18.5703Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.4916 18.5703C18.0394 18.5703 18.4834 19.0142 18.4834 19.562C18.4834 20.1097 18.0394 20.5537 17.4916 20.5537C16.9439 20.5537 16.4999 20.1097 16.4999 19.562C16.4999 19.0142 16.9439 18.5703 17.4916 18.5703Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.0205 18.5703C14.5682 18.5703 15.0122 19.0142 15.0122 19.562C15.0122 20.1097 14.5682 20.5537 14.0205 20.5537C13.4728 20.5537 13.0287 20.1097 13.0287 19.562C13.0287 19.0142 13.4728 18.5703 14.0205 18.5703Z"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.40043 17.7769C6.59135 17.7784 6.76229 17.8925 6.8327 18.0654C6.90311 18.2384 6.85895 18.4357 6.72101 18.5643L6.11468 19.1482H8.66756C8.68343 19.1474 8.69932 19.1474 8.71519 19.1482C8.88278 19.1564 9.03313 19.2512 9.10958 19.3968C9.18602 19.5424 9.17693 19.7167 9.08577 19.854C8.99458 19.9913 8.83515 20.0707 8.66756 20.0624H6.11468L6.72101 20.6462C6.85141 20.7583 6.90752 20.9314 6.86685 21.0961C6.82615 21.2609 6.69536 21.3902 6.52693 21.4321C6.35852 21.474 6.18014 21.4217 6.06339 21.2962L4.64005 19.9303C4.55043 19.8443 4.49998 19.7269 4.49998 19.6044C4.49998 19.4819 4.55043 19.3645 4.64005 19.2785L6.06339 17.9126C6.15235 17.8249 6.2739 17.776 6.40043 17.7769Z"
                fill="var(--menu-text-color)"
            />
          </svg>

          <span class="aside-nav__item-text">{{ $t("navigation.chat") }}</span>

          <div
              class="aside-nav__item-notifications"
              v-if="
              notificationCount.chat != null && notificationCount.chat !== false
            "
          >
            <span>
              {{
                notificationCount.chat > 20 ? "20+" : notificationCount.chat
              }}
            </span>
          </div>
        </router-link>

        <router-link v-if="$guard('read', 'Orders')" :to="{ name: 'orders' }" class="aside-nav__item">
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M22.1692 14.0483L21.3497 18.1893H10.5408L7.99756 8.54724H15.9853"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M4.5 5.26056H7.1132L7.99761 8.5472"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M10.5414 18.1894L8.68164 21.4895H23.8388"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.713 25.3396C12.713 24.4223 11.9773 23.6793 11.0707 23.6793C10.1634 23.6793 9.42773 24.4223 9.42773 25.3396C9.42773 26.2569 10.1634 27 11.0707 27C11.9773 27 12.713 26.2569 12.713 25.3396Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.1148 25.3396C23.1148 24.4223 22.3792 23.6793 21.4725 23.6793C20.5652 23.6793 19.8296 24.4223 19.8296 25.3396C19.8296 26.2569 20.5652 27 21.4725 27C22.3792 27 23.1148 26.2569 23.1148 25.3396Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.959 8.54737C26.959 5.48378 24.5022 3 21.4719 3C18.4416 3 15.9849 5.48378 15.9849 8.54737C15.9849 11.611 18.4416 14.0947 21.4719 14.0947C24.5022 14.0947 26.959 11.611 26.959 8.54737Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M18.7798 8.17205L20.6573 10.1647L23.8383 6.90381"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
            </svg>

            <span
                class="notification-count"
                v-if="newOrders !== 0 && $guard('read', 'chat')"
            >{{ newOrders }}</span>
          </div>
          <span class="aside-nav__item-text">{{ $t("navigation.orders") }}</span>
        </router-link>

        <!-- <router-link
          v-if="$guard('read', 'Requests')"
          to="/admin/requests"
          class="aside-nav__item"
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.8123 19.9445V26.9999H4.5V6.56113H19.8123V11.543"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.9027 20.436V25.2196H19.8125"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.59033 6.56142V4.78058H21.9026V11.0516"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.9931 19.9446V23.4389H21.9023"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.68066 4.78084V3H23.9929V11.5424"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.69531 11.0516H16.3366"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.69531 14.0713H15.2904"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.69531 17.0905H15.2904"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.69531 20.1102H16.3366"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.69531 23.1293H16.3366"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.9936 11.5425C23.3639 11.2288 22.6541 11.0515 21.9023 11.0515C19.3111 11.0515 17.2104 13.1527 17.2104 15.7439C17.2104 18.3356 19.3111 20.4363 21.9023 20.4363C24.494 20.4363 26.5947 18.3356 26.5947 15.7439"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19.8125 14.0713L21.9027 16.7807L26.5951 12.6003"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span class="aside-nav__item-text">{{
            $t("navigation.requests")
          }}</span>
        </router-link>-->

        <router-link v-if="$guard('read', 'Services')" to="/admin/services" class="aside-nav__item">
          <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M11.5881 7.17395H8.03204C6.90977 7.17395 6 7.92939 6 8.86128V25.3127C6 26.2446 6.90977 27 8.03204 27H23.2723C24.3946 27 25.3043 26.2446 25.3043 25.3127V8.86128C25.3043 7.92939 24.3946 7.17395 23.2723 7.17395H19.7162"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.3477 12.2728H20.6085"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.3477 15.5454H20.6085"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <ellipse
                cx="11.2173"
                cy="12.3913"
                rx="1.04348"
                ry="1.04348"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="11.2173"
                cy="16.0435"
                rx="1.04348"
                ry="1.04348"
                fill="var(--menu-text-color)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.6811 6.1304H17.6231C18.2765 6.1304 18.9032 6.40525 19.3652 6.89447C19.8273 7.3837 20.0868 8.04723 20.0868 8.7391V8.7391H11.2173V8.7391C11.2173 8.04723 11.4769 7.3837 11.9389 6.89447C12.401 6.40525 13.0276 6.1304 13.6811 6.1304Z"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <ellipse
                cx="15.3914"
                cy="4.56522"
                rx="1.56522"
                ry="1.56522"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <ellipse
                cx="11.2173"
                cy="19.6957"
                rx="1.04348"
                ry="1.04348"
                fill="var(--menu-text-color)"
            />
            <ellipse
                cx="11.2173"
                cy="22.8261"
                rx="1.04348"
                ry="1.04348"
                fill="var(--menu-text-color)"
            />
            <path
                d="M14.3477 19.3637H20.6085"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.3477 22.6363H20.6085"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>

          <span class="aside-nav__item-text">
            {{
              $t("navigation.services")
            }}
          </span>
        </router-link>

        <router-link
            v-if="$guard('read', 'Administrators')"
            to="/admin/administrators"
            class="aside-nav__item"
        >
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.0579 3C8.82214 3 7.38801 4.92693 7.38801 7.74453C7.31761 8.04533 7.28027 8.35787 7.28027 8.67893C7.28027 9.92107 7.83707 11.0432 8.73307 11.8453C9.09947 13.496 10.4584 14.7216 12.0797 14.7216C13.7005 14.7216 15.0595 13.496 15.4259 11.8453C16.3219 11.0432 16.8792 9.92107 16.8792 8.67893C16.8792 8.35413 16.8403 8.03733 16.7683 7.7328C16.7683 4.37653 15.3368 3 12.0579 3Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M16.7562 16.3576C16.0506 16.0632 15.5434 15.8685 15.5434 15.8685C15.5434 15.8685 14.9013 20.9613 12.057 23.7139C9.12048 20.9149 8.57008 15.8685 8.57008 15.8685C8.57008 15.8685 5.81754 16.924 4.21168 17.8413C2.60581 18.7587 1.41274 21.7411 1.50501 23.4387C2.69754 25.1357 12.057 25.2275 12.057 25.2275C12.057 25.2275 13.7695 25.2109 15.8229 25.0584"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.0015 17.5203H13.066L12.7449 19.0339H11.3225L11.0015 17.5203Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.066 20.8693L12.1023 22.9797L11.0015 20.8693L11.3225 19.3557H12.7444L13.066 20.8693Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M9.37305 3.61923C9.37305 3.61923 10.933 7.97763 13.4562 7.93177C16.9042 7.86937 16.7576 7.24377 16.7576 7.24377"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M10.8409 6.32599C10.8409 6.32599 9.60252 8.57399 7.40039 7.74839"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M25.8567 21.5859C25.8567 19.3118 24.013 17.4686 21.7394 17.4686C19.4653 17.4686 17.6221 19.3118 17.6221 21.5859C17.6221 23.8601 19.4653 25.7033 21.7394 25.7033C24.013 25.7033 25.8567 23.8601 25.8567 21.5859Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M21.7393 16.1719V17.4684"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M25.5677 17.7576L24.6509 18.6744"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M27.1535 21.5859H25.8569"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M25.5677 25.4144L24.6509 24.4976"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M21.7393 27V25.7035"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M17.9111 25.4144L18.8279 24.4976"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M16.3252 21.5859H17.6223"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M17.9111 17.7576L18.8279 18.6744"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.9696 21.586C23.9696 20.354 22.9707 19.3556 21.7392 19.3556C20.5072 19.3556 19.5088 20.354 19.5088 21.586C19.5088 22.818 20.5072 23.8164 21.7392 23.8164C22.9707 23.8164 23.9696 22.818 23.9696 21.586Z"
                  stroke="var(--menu-text-color)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
            </svg>
          </div>

          <span class="aside-nav__item-text">
            {{
              $t("navigation.administrators")
            }}
          </span>
        </router-link>

        <router-link to="/admin/todo" class="aside-nav__item">
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <svg
                id="Layer_1_1_"
                enable-background="new 0 0 64 64"
                width="30"
                height="30"
                viewBox="0 0 64 64"
                xmlns="http://www.w3.org/2000/svg"
                fill="var(--menu-text-color)"
            >
              <path
                  d="m8 19h8c.55225 0 1-.44775 1-1v-3h-2v2h-6v-6h3v-2h-4c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1z"
              />
              <path
                  d="m12 13.58594-1.29297-1.29297-1.41406 1.41406 2 2c.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l6-6-1.41406-1.41406z"
              />
              <path
                  d="m15 30h-6v-6h3v-2h-4c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-3h-2z"
              />
              <path
                  d="m12 26.58594-1.29297-1.29297-1.41406 1.41406 2 2c.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l6-6-1.41406-1.41406z"
              />
              <path
                  d="m16 35h-8c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-8c0-.55225-.44775-1-1-1zm-1 8h-6v-6h6z"
              />
              <path
                  d="m16 48h-8c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-8c0-.55225-.44775-1-1-1zm-1 8h-6v-6h6z"
              />
              <path
                  d="m57.70703 5.29297c-.39062-.39062-1.02344-.39062-1.41406 0l-6.29297 6.29297-9.29297-9.29297c-.1875-.1875-.44189-.29297-.70703-.29297h-37c-.55225 0-1 .44775-1 1v58c0 .55225.44775 1 1 1h47c.55225 0 1-.44775 1-1v-39.58594l10.70703-10.70703c.39062-.39062.39062-1.02344 0-1.41406zm-8.70703 54.70703h-45v-56h35.58594l8 8h-6.58594v-5h-2v6c0 .55225.44775 1 1 1h7.58594l-23.29297 23.29297c-.10986.10986-.19238.24365-.2417.39062l-2 6c-.11963.35938-.02637.75586.2417 1.02344.19043.19092.44629.29297.70703.29297.10596 0 .2124-.0166.31641-.05127l6-2c.14697-.04932.28076-.13184.39062-.2417l19.29297-19.29297zm-23.56299-20.14893 1.71191 1.71191-2.56787.85596zm3.56299.73487-2.58594-2.58594 30.58594-30.58594 2.58594 2.58594z"
              />
              <path d="m45 56h2v2h-2z" />
              <path d="m41 56h2v2h-2z" />
              <path d="m37 56h2v2h-2z" />
            </svg>
          </div>

          <span class="aside-nav__item-text">Todo</span>
        </router-link>

        <router-link to="/admin/tags" class="aside-nav__item">
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <svg
                id="Capa_1"
                enable-background="new 0 0 512 512"
                viewBox="0 0 512 512"
                width="30"
                height="30"
                xmlns="http://www.w3.org/2000/svg"
                fill="var(--menu-text-color)"
            >
              <g>
                <circle cx="97.712" cy="70.624" r="13.982" />
                <ellipse
                    cx="140.723"
                    cy="70.624"
                    rx="13.982"
                    ry="13.982"
                    transform="matrix(.707 -.707 .707 .707 -8.722 120.191)"
                />
                <circle cx="183.734" cy="70.624" r="13.982" />
                <path
                    d="m511.979 101.953c-.691-21.584-19.622-39.216-41.218-39.216h-9.025v-3.951c0-21.362-17.317-38.679-38.679-38.679h-350.631c-21.362 0-38.679 17.317-38.679 38.679v260.302l-24.207 24.207c-6.152 6.152-9.54 14.332-9.54 23.033s3.388 16.881 9.54 23.033l92.992 92.992c6.152 6.153 14.332 9.54 23.033 9.54s16.881-3.388 23.033-9.54l69.218-69.218h39.398c3.841 0 7.278-2.759 7.741-6.572.555-4.57-2.996-8.454-7.456-8.454h-24.656l117.846-117.846c7.581-7.581 11.357-18.053 10.359-28.729l-5.163-55.179h50.84c14.508 0 28.332-4.399 39.983-12.535v190.638c0 13.062-10.589 23.651-23.651 23.651h-129.161c-3.841 0-7.278 2.759-7.741 6.572-.555 4.57 2.996 8.454 7.456 8.454h129.446c21.362 0 38.679-17.317 38.679-38.679v-204.099l38.386-38.386c7.975-7.976 12.219-18.688 11.857-30.018zm-66.35 63.26c-10.318 10.318-24.311 16.114-38.902 16.114h-52.247l-1.553-16.602c-1.354-14.465-12.845-25.828-27.323-27.018l-85.507-7.033c-10.531-.869-20.856 2.922-28.327 10.394l-22.7 22.699c-2.515 2.515-3.138 6.491-1.208 9.478 2.706 4.189 8.357 4.623 11.676 1.305l22.857-22.857c4.343-4.345 10.349-6.544 16.47-6.043l85.506 7.033c7.204.593 12.92 6.246 13.594 13.442l1.422 15.202h-11.517c-1.343-3.89-3.562-7.541-6.662-10.641-10.936-10.935-28.731-10.937-39.669 0-10.936 10.936-10.936 28.732 0 39.668 5.469 5.468 12.651 8.203 19.834 8.203 7.184 0 14.366-2.734 19.835-8.203 3.979-3.979 6.503-8.866 7.586-14h11.998l5.294 56.578c.581 6.208-1.615 12.296-6.023 16.704l-202.09 202.091c-6.852 6.852-17.962 6.852-24.815 0l-92.738-92.738c-2.862-2.862-4.816-6.566-5.275-10.587-.621-5.448 1.221-10.682 5.021-14.482l154.899-154.899c3.153-3.153 2.918-8.412-.706-11.25-3.024-2.369-7.405-1.889-10.121.827l-115.464 115.463v-182.92h367.701c3.841 0 7.278-2.759 7.741-6.572.555-4.57-2.996-8.454-7.456-8.454h-367.986v-47.329c0-13.063 10.589-23.652 23.652-23.652h350.632c13.062 0 23.651 10.589 23.651 23.651v3.951h-55.281c-3.593-11.633-14.918-19.905-27.946-18.783-13.056 1.125-23.531 11.866-24.356 24.944-.98 15.54 11.384 28.498 26.717 28.498 12.29 0 22.665-8.327 25.798-19.633h55.069v86.368zm-132.441 30.748c-.626 1.364-1.571 2.566-2.607 3.767-3.219 3.733-10.081 5.55-15.818 2.035-4.089-2.488-6.414-6.688-6.414-11.244-.021-5.742 5.033-13.006 13.024-13.017 3.334 0 6.669 1.269 9.208 3.808.369.369.704.759 1.019 1.16-2.124 1.327-3.542 3.68-3.542 6.37.001 3.315 2.15 6.124 5.13 7.121zm62.467-118.898c-2.193 3.331-6.03 5.489-10.35 5.295-6.009-.27-10.961-5.251-11.197-11.262-.263-6.69 5.102-12.216 11.735-12.216 3.854 0 7.271 1.875 9.414 4.751-2.357 1.268-3.961 3.756-3.961 6.62 0 3.021 1.787 5.619 4.359 6.812zm113.84 44.283-27.759 27.759v-71.341h9.158c13.613 0 25.261 10.433 26.036 24.023.421 7.376-2.259 14.383-7.435 19.559z"
                />
                <path
                    d="m139.953 291.369c-3.549-1.479-7.597-.677-10.312 2.045s-3.509 6.77-2.021 10.315c.023.056.048.112.072.167l36.616 81.666c1.25 2.788 3.99 4.441 6.86 4.441 1.027 0 2.072-.212 3.069-.659 3.787-1.698 5.479-6.144 3.782-9.93l-6.999-15.614 28.857-28.857 15.554 7.031c3.783 1.711 8.232.031 9.941-3.751 1.709-3.781.029-8.232-3.752-9.941l-81.464-36.823c-.067-.032-.134-.061-.203-.09zm45.288 36.958-20.8 20.8-16.984-37.879z"
                />
                <path
                    d="m237.084 304.738c13.337 0 25.876-5.194 35.306-14.625 18.372-18.372 16.685-45.722-4.102-66.51-1.41-1.409-3.32-2.201-5.313-2.201s-3.903.791-5.313 2.201l-17.944 17.945c-2.934 2.934-2.934 7.691 0 10.625 2.934 2.935 7.691 2.934 10.625 0l12.237-12.237c8.348 11.32 12.047 26.689-.816 39.551-6.592 6.592-15.357 10.223-24.68 10.223s-18.088-3.631-24.68-10.223-10.223-15.357-10.223-24.68 3.631-18.088 10.223-24.681c4.947-4.946 11.173-8.26 18.007-9.583 4.074-.789 6.737-4.731 5.949-8.804-.788-4.074-4.73-6.738-8.804-5.949-9.788 1.894-18.702 6.636-25.776 13.71-9.431 9.43-14.625 21.969-14.625 35.306s5.194 25.875 14.625 35.305c9.429 9.433 21.968 14.627 35.304 14.627z"
                />
                <path
                    d="m90.607 351.925 11.318-11.318c2.934-2.934 2.934-7.691 0-10.625s-7.691-2.934-10.625 0l-33.128 33.128c-2.934 2.934-2.934 7.691 0 10.625 1.467 1.467 3.39 2.201 5.313 2.201s3.846-.734 5.313-2.201l11.184-11.184 54.673 54.673c1.467 1.467 3.39 2.201 5.313 2.201s3.846-.734 5.313-2.201c2.934-2.934 2.934-7.691 0-10.625z"
                />
              </g>
            </svg>
          </div>

          <span class="aside-nav__item-text">Tags</span>
        </router-link>

        <router-link to="/admin/pdf" class="aside-nav__item">
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <svg
                viewBox="0 -1 429.69021 429"
                width="30"
                height="30"
                xmlns="http://www.w3.org/2000/svg"
                fill="var(--menu-text-color)"
            >
              <path
                  d="m127.273438 185.078125-.015626.273437c-1.058593 18.542969 9.328126 35.914063 26.46875 44.242188l.175782.085938c6.042968 2.890624 10.996094 7.65625 14.121094 13.582031l.070312.128906c8.636719 16.445313 26.5 26.414063 45.542969 25.414063l.289062-.015626c6.90625-.386718 13.761719 1.394532 19.605469 5.097657 16.125 10.085937 36.59375 10.085937 52.71875 0 5.84375-3.703125 12.699219-5.484375 19.605469-5.097657l.289062.015626c19.011719 1.007812 36.898438-8.96875 45.554688-25.441407l.042969-.089843c3.136718-5.941407 8.101562-10.714844 14.164062-13.609376l.140625-.070312c17.140625-8.332031 27.53125-25.699219 26.46875-44.246094l-.015625-.257812c-.351562-6.53125 1.460938-12.996094 5.164062-18.390625 10.660157-15.546875 10.660157-36.046875.003907-51.597657-3.699219-5.390624-5.519531-11.851562-5.167969-18.382812l.015625-.273438c1.0625-18.546874-9.328125-35.914062-26.484375-44.25l-.15625-.078124c-6.03125-2.882813-10.972656-7.625-14.101562-13.535157l-.089844-.175781c-8.640625-16.445312-26.527344-26.410156-45.539063-25.414062l-.292969.015624c-6.902343.386719-13.757812-1.394531-19.597656-5.097656h-.007812c-16.125-10.085937-36.59375-10.085937-52.71875 0-5.84375 3.699219-12.699219 5.480469-19.605469 5.09375l-.289063-.015625c-19.015624-1.007812-36.898437 8.96875-45.535156 25.410157l-.066406.121093c-3.128906 5.9375-8.085938 10.707031-14.136719 13.601563l-.164062.078125c-17.140625 8.328125-27.53125 25.699219-26.46875 44.246093l.015625.257813c.351562 6.53125-1.460938 12.996094-5.164063 18.386719-10.660156 15.550781-10.660156 36.054687 0 51.601562 3.699219 5.390625 5.515625 11.855469 5.160157 18.386719zm8.007812-60.902344c5.714844-8.320312 8.515625-18.296875 7.96875-28.375l-.015625-.273437c-.5625-12.289063 6.335937-23.703125 17.472656-28.925782l.136719-.066406c9.136719-4.375 16.617188-11.578125 21.335938-20.539062l.078124-.148438c5.738282-10.929687 17.757813-17.554687 30.523438-16.875l.28125.011719c10.214844.574219 20.351562-2.058594 28.992188-7.535156 10.910156-6.824219 24.753906-6.824219 35.664062 0 8.640625 5.46875 18.777344 8.105469 28.988281 7.539062l.28125-.015625c12.828125-.671875 24.789063 5.945313 30.511719 16.84375l.105469.199219c4.71875 8.949219 12.191406 16.140625 21.316406 20.511719l.132813.066406c11.3125 5.5 18.179687 16.855469 17.488281 28.9375l-.015625.285156c-.546875 10.078125 2.257812 20.050782 7.972656 28.371094 6.90625 10.074219 6.902344 23.355469-.007812 33.425781-5.710938 8.324219-8.511719 18.300781-7.964844 28.378907l.015625.269531c.691406 12.082031-6.175781 23.441406-17.492188 28.945312l-.117187.054688c-9.144532 4.382812-16.632813 11.59375-21.355469 20.570312l-.058594.117188c-5.742187 10.929687-17.742187 17.558593-30.527343 16.875l-.277344-.015625c-10.214844-.570313-20.355469 2.066406-29 7.539062-10.90625 6.820313-24.75 6.820313-35.65625 0-7.859375-4.980468-16.976563-7.621094-26.28125-7.613281-.902344 0-1.808594.023437-2.714844.074219l-.28125.011718c-12.597656.800782-24.515625-5.792968-30.535156-16.890624l-.082032-.152344c-4.710937-8.945313-12.179687-16.132813-21.300781-20.503906l-.148437-.074219c-11.316406-5.5-18.183594-16.859375-17.488282-28.9375l.015626-.285157c.542968-10.078124-2.261719-20.054687-7.972657-28.371093-6.902343-10.074219-6.898437-23.355469.011719-33.421875zm0 0"
              />
              <path
                  d="m208.269531 223.601562c3.746094 2.339844 8.679688 1.195313 11.019531-2.550781l94.769532-151.820312c1.546875-2.425781 1.675781-5.496094.332031-8.039063-1.34375-2.546875-3.953125-4.171875-6.828125-4.261718-2.875-.089844-5.578125 1.371093-7.078125 3.828124l-94.765625 151.820313c-2.339844 3.75-1.199219 8.683594 2.550781 11.023437zm0 0"
              />
              <path
                  d="m216.761719 141.292969c19.480469 0 35.332031-18.074219 35.332031-40.289063s-15.851562-40.285156-35.332031-40.285156-35.328125 18.070312-35.328125 40.285156 15.847656 40.289063 35.328125 40.289063zm0-64.574219c10.660156 0 19.332031 10.894531 19.332031 24.285156s-8.671875 24.289063-19.332031 24.289063c-10.65625 0-19.328125-10.902344-19.328125-24.289063 0-13.386718 8.671875-24.285156 19.328125-24.285156zm0 0"
              />
              <path
                  d="m267.683594 180.800781c0 22.214844 15.847656 40.285157 35.328125 40.285157s35.332031-18.074219 35.332031-40.285157c0-22.207031-15.847656-40.285156-35.328125-40.285156-19.484375 0-35.332031 18.066406-35.332031 40.285156zm54.660156 0c0 13.390625-8.671875 24.285157-19.332031 24.285157-10.65625 0-19.328125-10.894532-19.328125-24.285157s8.671875-24.285156 19.328125-24.285156c10.660156 0 19.332031 10.886719 19.332031 24.285156zm0 0"
              />
              <path
                  d="m428.652344 313.644531c-10.59375-18.800781-34.085938-25.960937-53.363282-16.265625l-62.667968 29.609375c-8.652344-16.089843-25.25-26.332031-43.515625-26.847656l-57.851563-1.59375c-9.160156-.261719-18.148437-2.585937-26.292968-6.789063l-5.886719-3.050781c-30.140625-15.710937-66.066407-15.671875-96.175781.101563l.367187-13.335938c.121094-4.417968-3.359375-8.097656-7.777344-8.21875l-63.4375-1.746094c-4.417969-.121093-8.09375 3.359376-8.214843 7.777344l-3.83203175 139.214844c-.12109425 4.417969 3.35937475 8.097656 7.77734375 8.21875l63.4375 1.746094h.222656c4.332032-.003906 7.875-3.453125 7.996094-7.78125l.179688-6.660156 16.480468-8.824219c6.46875-3.480469 14.035156-4.308594 21.101563-2.308594l98.410156 27.621094c.171875.050781.34375.089843.519531.128906 7.113282 1.488281 14.363282 2.234375 21.632813 2.230469 15.390625.007812 30.601562-3.308594 44.589843-9.730469.34375-.15625.675782-.335937.992188-.539063l142.6875-92.300781c3.558594-2.296875 4.707031-6.972656 2.621094-10.65625zm-412.433594 91.296875 3.390625-123.214844 47.445313 1.304688-3.394532 123.21875zm258.921875-2.097656c-17.378906 7.84375-36.789063 10.007812-55.46875 6.1875l-98.148437-27.542969c-11.042969-3.125-22.871094-1.828125-32.976563 3.605469l-8.421875 4.507812 2.257812-81.925781c26.683594-17.75 60.910157-19.574219 89.332032-4.765625l5.886718 3.050782c10.289063 5.3125 21.640626 8.246093 33.214844 8.578124l57.851563 1.59375c16.25.464844 30.050781 12.035157 33.347656 27.957032l-86.171875-2.371094c-4.417969-.121094-8.09375 3.359375-8.214844 7.777344-.121094 4.417968 3.359375 8.097656 7.777344 8.21875l95.097656 2.617187h.226563c4.328125-.003906 7.871093-3.453125 7.992187-7.78125.097656-3.476562-.164062-6.957031-.773437-10.378906l64.265625-30.371094.1875-.089843c9.117187-4.617188 20.144531-3.074219 27.640625 3.867187zm0 0"
              />
            </svg>
          </div>

          <span class="aside-nav__item-text">Angebot &amp; Arbeitsschein</span>
        </router-link>

        <!-- <router-link to="/_4screen" class="aside-nav__item">
          <div class="aside-nav__item-icon aside-nav__item-icon_flex">
            <svg
              id="Icons"
              viewBox="0 0 74 74"
              width="30"
              height="30"
              xmlns="http://www.w3.org/2000/svg"
              fill="var(--menu-text-color)"
            >
              <path
                d="m67 59h-60a5.006 5.006 0 0 1 -5-5v-36h2v36a3 3 0 0 0 3 3h60a3 3 0 0 0 3-3v-44a3 3 0 0 0 -3-3h-60a3 3 0 0 0 -3 3v4h-2v-4a5.006 5.006 0 0 1 5-5h60a5.006 5.006 0 0 1 5 5v44a5.006 5.006 0 0 1 -5 5z"
              />
              <path
                d="m52 69h-30a1 1 0 0 1 -1-1c0-5 5.269-5 7-5h18c1.731 0 7 0 7 5a1 1 0 0 1 -1 1zm-28.879-2h27.758c-.349-1.231-1.556-2-4.879-2h-18c-3.323 0-4.53.769-4.879 2z"
              />
              <path
                d="m45 65h-16a1 1 0 0 1 -1-1v-6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1zm-15-2h14v-4h-14z"
              />
              <path d="m3 49h68v2h-68z" />
              <path d="m33 53h8v2h-8z" />
            </svg>
          </div>

          <span class="aside-nav__item-text">4 screen</span>
        </router-link> -->
      </div>
    </div>

    <!-- <div class="aside-nav__themes">
      <span
        class="aside-nav__theme"
        :class="{
          'aside-nav__theme_active': !isDark,
        }"
        @click="changeTheme('white')"
      >White</span>
      <span
        class="aside-nav__theme"
        :class="{
          'aside-nav__theme_active': isDark,
        }"
        @click="changeTheme('dark')"
      >Dark</span>
    </div>-->

    <div class="aside-nav__bottom">
      <div v-if="infoRootLink">
        <a :href="infoRootLink" class="info-link" target="_blank">
          <span>Auskunft</span>

          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path
              d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z"
            />
          </svg>
        </a>
      </div>

      <div class="theme-switcher">
        <span
          class="theme-switcher__label theme-switcher__label_light"
          :class="{
            'theme-switcher__label_active': !isDark,
          }"
        >Hell</span>
        <button type="reset" class="theme-switcher__state" @click="toggleTheme">
          <span
            class="theme-switcher__circle"
            :class="{
              'theme-switcher__circle_active': !isDark,
            }"
          ></span>
        </button>
        <span
          class="theme-switcher__label theme-switcher__label_dark"
          :class="{
            'theme-switcher__label_active': isDark,
          }"
        >Dunkel</span>
      </div>

      <div class="aside-nav__profile">
        <div class="aside-nav__profile-image">
          <img :src="admin.big_image" alt />
        </div>
        <div class="aside-nav__profile-links">
          <router-link
            class="aside-nav__profile-link"
            to="/admin"
          >{{ admin.first_name }} {{ admin.last_name }}</router-link>
          <button class="aside-nav__profile-logout" @click="logout">Ausloggen</button>
        </div>
      </div>

      <p class="aside-nav__version">v{{ $config.appVersion }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import logo from '@/components/controls/logo'

export default {
    components: { logo },
    data() {
        return {
            role: window.globalConfig.role,
            notificationCount: {
                chat: null,
                orders: null,
                requests: null,
                clients: null,
            },
        }
    },
    computed: {
        ...mapGetters({
            updateCount: 'updateCountGetters',
            newOrders: 'orders/newOrdersGetters',
            newClients: 'newClientsGetters',
            adminData: 'adminDataGetters',

            activeTheme: 'activeTheme',
            infoRootLink: 'infoRootLink',
        }),
        admin() {
            return this.$store.state.admin.data
        },
        notifications: {
            get() {
                return this.$store.state.notifications.notifications
            },
        },
        isDark() {
            return this.activeTheme === 'dark'
        },
        logoSrc() {
            return this.isDark ? '/images/whiteCat.svg' : '/images/onGreen.svg'
        },
    },
    watch: {
        notifications(v) {
            let chat = 0
            const orders = 0

            v.forEach((e) => {
                if (e.type === 'message') chat += e.items.length
            })

            this.notificationCount.chat = chat
            this.notificationCount.orders = orders
        },
        updateCount(v) {
            if (!this.isUpdated(v)) {
                this.countNotifications()
                this.toggleUpdateCount()
            }
        },
    },
    methods: {
        ...mapMutations({
            toggleUpdateCount: 'toggleUpdateCount',
            setTheme: 'setTheme',
            setLink: 'setLink',
        }),
        ...mapActions({
            fetchNewOrdersCount: 'orders/fetchNewOrdersCount',
            fetchNewClientsCount: 'fetchNewClientsCount',
            logOut: 'logOut',
        }),
        logout() {
            this.logOut({ $router: this.$router })
        },
        isUpdated(v) {
            return v === true
        },
        toggleTheme() {
            this.changeTheme(this.isDark ? 'white' : 'dark')

            document.body.classList.remove(
                !this.isDark ? 'dark-theme' : 'light-theme',
            )
            document.body.classList.add(!this.isDark ? 'light-theme' : 'dark-theme')
            // document.body.classList.add('dark')
        },
        changeTheme(v) {
            this.setTheme(v)
        },
        countNotifications() {
            this.$store.state.notifications.notifications = [
                ...new Set(this.$store.state.notifications.notifications),
            ]

            this.$store.state.notifications.notifications.forEach((e) => {
                if (e.type === 'message') this.notificationCount.chat += e.items.length
                else if (e.type === 'new_request') ++this.notificationCount.orders
                else if (e.type === 'new_client') ++this.notificationCount.clients
            })
        },
    },
    created() {
        this.countNotifications()
        this.fetchNewOrdersCount()
        this.fetchNewClientsCount()

        if (this.adminData && this.adminData.role) {
            window.$role = this.adminData.role.slug
        }
    },
}
</script>

<style lang="scss" scoped>
.info-link {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 2px solid #f6bb0b;
  margin-bottom: 16px;
  padding: 4px 0;
  color: #f6bb0b;

  svg {
    display: inline-block;
    margin-left: 8px;
    fill: #f6bb0b;
  }
}

.theme-switcher {
  display: flex;
  margin-bottom: 36px;

  &__label {
    font-size: 13px;
    line-height: 16px;
    font-family: "lexend_deca", serif;
    color: #828d99;

    &_active {
      color: var(--switcher-bold-color);
    }
  }

  &__state {
    width: 36px;
    height: 16px;
    border: 1px solid var(--menu-text-color);
    border-radius: 12px;
    margin: 0 12px;
    position: relative;
    padding: 2px;
    background: transparent;
    cursor: pointer;
  }

  &__circle {
    width: 11px;
    height: 11px;
    background-color: var(--menu-text-color);
    display: block;
    border-radius: 50%;
    right: 1px;
    top: 1px;
    position: absolute;

    &_active {
      right: unset;
      left: 1px;
    }
  }
}

.add-order {
  width: 100%;
  padding: 0 16px;
  margin-top: 10px;

  &__btn {
    width: 100%;
    border: 1px solid #9bcd82;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.3s ease-in;

    &:hover {
      background-color: var(--bg-color2);
    }
  }

  &__text {
    color: var(--bg-color-green);
    margin-left: 12px;
    font-size: 15px;
  }
}

.aside-nav {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  width: 100%;
  max-width: 199px;
  height: 100%;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.16);
  background: var(--bg-color);
  border-right: 1px solid var(--border-color);
  transition: all 0.2s ease-in;

  &__profile-image {
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
  }

  &__head {
    display: flex;
    justify-content: center;
    padding: 14px 0;
    transition: all 0.2s ease-in;
    border-bottom: 1px solid var(--border-color);
  }

  &__menu {
    margin-top: 40px;
  }

  &__item {
    padding: 12px 0 12px 16px;
    display: flex;
    align-items: center;
    transition: all 0.2s ease-in;
    background: transparent;
    position: relative;

    &:hover,
    &:active,
    &:focus {
      background: var(--hover-bg-color);
    }

    &-icon {
      width: 30px;
      height: 30px;
      object-fit: contain;

      img {
        width: 100%;
      }
    }

    &-text {
      margin-left: 6px;
      font-size: 16px;
      line-height: 24px;
      color: var(--menu-text-color);
    }

    &-notifications {
      position: absolute;
      right: 19px;

      span {
        background: #ff4a7a;
        border-radius: 4px;
        width: 100%;
        height: 16px;
        font-size: 11px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px 4px;
      }
    }
  }

  &__version {
    color: #828d99;
    margin-top: 6px;
  }

  &__themes {
    padding: 12px 0 12px 16px;
  }

  &__theme {
    color: var(--menu-text-color);
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;

    &_active {
      text-decoration: underline;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  &__bottom {
    position: relative;
    width: calc(100% - 16px);
    padding: 0 0 14px 16px;
  }

  &__profile {
    display: flex;

    &-links {
      display: flex;
      flex-direction: column;
      margin-left: 6px;
    }

    &-link {
      color: var(--menu-text-color);
      font-weight: 600;
      line-height: 18px;
      background-color: transparent !important;
      transition: all 0.2s ease-in;

      &:hover {
        text-decoration: underline;
      }
    }

    &-logout {
      font-size: 13px;
      line-height: 16px;
      color: #828d99;
      background-color: transparent;
      border: none;
      width: max-content;
      padding: 0;
      margin-top: 3px;
      cursor: pointer;
    }
  }

  & .router-link-exact-active {
    background: var(--hover-bg-color);
  }
}
</style>
